import React from 'react';


export default function Footer() {
    return (
        <footer>
            <p className='centered'>(C) {new Date().getFullYear()} IoT Fortress is developed by <a rel="noopener noreferrer" target='_blank' href="https://dyquo.com">Dyquo Labs</a></p>
        </footer>
    )
}